import { EYLF_OUTCOMES } from "../lib/eylf";

type Props = {
  selected: string[];
  onChange: (codes: string[]) => void;
};

export function EylfChips({ selected, onChange }: Props) {
  const toggle = (id: string) => {
    if (selected.includes(id)) {
      onChange(selected.filter((c) => c !== id));
    } else {
      onChange([...selected, id]);
    }
  };

  return (
    <div className="space-y-3">
      {EYLF_OUTCOMES.map((o) => (
        <div key={o.number}>
          <h4 className="text-sm font-medium mb-1">
            Outcome {o.number}: {o.title_en}
          </h4>
          <div className="flex flex-wrap gap-1.5">
            {o.subcodes.map((s) => {
              const isSelected = selected.includes(s.id);
              return (
                <button
                  key={s.id}
                  type="button"
                  onClick={() => toggle(s.id)}
                  aria-pressed={isSelected}
                  title={s.en}
                  className={
                    isSelected
                      ? "px-2 py-1 rounded-full text-xs font-medium bg-[#ff6b35] text-white"
                      : "px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }
                >
                  {s.id}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
